
import { useStore } from '@/store'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  setup() {
    const store = useStore()
    const cachedViews = computed(() => store.state.tagViews.cachedViews)
    return {
      cachedViews
    }
  }
})
